import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { saveAs } from 'file-saver';
import { CmdModal, CmdModalFooterButton } from '@commander-services/gui-components';
import CustomTooltip from '../CustomTooltip';
import useTooltip from '../hooks/useTooltip';
import { IAttachment, RefuelingsRecord } from '../../Refuelings/types';
import ApiService from '../../../Services/ApiService';

interface IDownloadCellProps {
  data: RefuelingsRecord;
  align?: string;
}

function DownloadCell({ data, align = 'center' }: IDownloadCellProps) {
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } = useTooltip();
  const { formatMessage: f } = useIntl();
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const tooltipContent = (value: string) => {
    switch (value) {
      case 'current':
        return f({ id: 'enum.periodLocks.status.tooltip.current' });
      case 'locked':
        return f({ id: 'enum.periodLocks.status.tooltip.locked' });
      case 'unlocked':
        return f({ id: 'enum.periodLocks.status.tooltip.unlocked' });
      default:
        return f({ id: 'enum.periodLocks.status.tooltip.waiting' });
    }
  };

  const handleDownloadFile = async (file) => {
    const response = await ApiService.download(
      `${file.path}?customerId=${data.customer.id}`,
      file.mimeType
    );
    const contentDisposition = response.headers['content-disposition'];
    const contentType = response.headers['content-type'];

    if (response) {
      const filenameRegex = /filename="([^"]*)"/;
      const filenameMatch = contentDisposition.match(filenameRegex);
      const filename = filenameMatch ? filenameMatch[1] : file.name;

      const typeRegex = /([^;]*)/;
      const typeMatch = contentType.match(typeRegex);
      const type = typeMatch ? typeMatch[0] : file.mimeType;

      const blob = new Blob([response.data], { type });
      saveAs(blob, filename);
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    if (data.attachments.length === 1) {
      handleDownloadFile(data.attachments[0]);
    } else {
      setIsDownloadModalOpen(true);
    }
  };
  const handleText = () => {
    if (data?.attachments?.length === 1) {
      return data.attachments[0].name;
    }

    return `${data.attachments.length} +`;
  };

  const handleCloseDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  const buttons: CmdModalFooterButton[] = [
    {
      id: 'close-modal',
      type: 'button',
      className: 'e-button',
      title: f({ id: 'alarms.modal.rule.button.close' }),
      tooltip: f({ id: 'alarms.modal.rule.button.close.tooltip' }),
      closeCallback: handleCloseDownloadModal,
    },
  ];

  return (
    <div
      className={`text-cell align-${align}`}
      style={{ flex: 1 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* <CustomTooltip content={tooltipContent(data)} show={hover} position={tooltipPos}> */}
      {data?.attachments.length > 0 && (
        <div
          className="e-table-label e-table-label--default cursor-pointer"
          ref={textRef}
          onClick={handleOnClick}
        >
          {/* <i className={`cmd-icon ${handleIconClass(data)}`} /> */}
          {handleText()}
        </div>
      )}
      {isDownloadModalOpen && data?.attachments.length > 1 && (
        <CmdModal
          id="download-cell-modal"
          title={f({ id: 'alarms.modal.rule.title' })}
          footerButtons={buttons}
          usePortal
          hideFooter
        >
          {data.attachments.map((file: IAttachment) => (
            <div
              key={file.path}
              className="flex justify-between items-center py-[4px] cursor-pointer"
            >
              <span>{file.name}</span>
              <div className="flex space-x-2">
                <i
                  className="cmd-icon cmd-icon-download cursor-pointer"
                  onClick={() => handleDownloadFile(file)}
                />
              </div>
            </div>
          ))}
        </CmdModal>
      )}
      {/* </CustomTooltip> */}
    </div>
  );
}

export default DownloadCell;
